import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

import { StyledNotificationProps } from './@types'

export const Core = styled.span<StyledNotificationProps>`
  margin: 0;
  padding: 1rem 1.6rem;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.8rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  border-radius: ${(props) => props.round};
  justify-content: ${(props) => props.align};
  color: ${(props) => props.theme.color.textHintSecond};
  background-color: ${(props) => transparentize(0.86, props.theme.color.elementBgThird)};
  transition: all 0.26s ease;
  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;
    `}
  ${({ type }) =>
    type === 'success' &&
    css`
      color: ${(props) => props.theme.color.success};
      background-color: ${(props) => transparentize(0.86, props.theme.color.success)};
      ${({ isClickable }) =>
        isClickable &&
        css`
          &:hover:not([disabled]),
          &:focus:not([disabled]),
          &:active:not([disabled]) {
            box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.success)};
          }
        `}
    `}
  ${({ type }) =>
    type === 'info' &&
    css`
      color: ${(props) => props.theme.color.elementBgThird};
      background-color: ${(props) => transparentize(0.86, props.theme.color.elementBgThird)};
      ${({ isClickable }) =>
        isClickable &&
        css`
          &:hover:not([disabled]),
          &:focus:not([disabled]),
          &:active:not([disabled]) {
            box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.elementBgThird)};
          }
        `}
    `}
  ${({ type }) =>
    type === 'warning' &&
    css`
      color: ${(props) => props.theme.color.warning};
      background-color: ${(props) => transparentize(0.86, props.theme.color.warning)};
      ${({ isClickable }) =>
        isClickable &&
        css`
          &:hover:not([disabled]),
          &:focus:not([disabled]),
          &:active:not([disabled]) {
            box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.warning)};
          }
        `}
    `}
  ${({ type }) =>
    type === 'error' &&
    css`
      color: ${(props) => props.theme.color.danger};
      background-color: ${(props) => transparentize(0.86, props.theme.color.danger)};
      ${({ isClickable }) =>
        isClickable &&
        css`
          &:hover:not([disabled]),
          &:focus:not([disabled]),
          &:active:not([disabled]) {
            box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.danger)};
          }
        `}
    `}
`

export const Title = styled.h4`
  margin: 0 0 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.47;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Wrap = styled.div<{ margin: string }>`
  margin: ${(props) => props.margin};
  width: auto;
`
